'use client'

// src/utils/events.ts
var listTicketsByGroup = (tickets) => {
  const groupedTickets = Object.entries(groupTicketsByGroupName(tickets));
  const ungroupedTickets = tickets.filter((ticket) => !ticket.has_group);
  return {
    groupedTickets,
    ungroupedTickets
  };
};
var groupTicketsByGroupName = (tickets) => {
  const grouped = {};
  for (let i = 0; i < tickets.length; i++) {
    const ticket = tickets[i];
    const key = ticket.group_name || "";
    if (ticket.sale_status === "past" || !ticket.has_group)
      continue;
    if (grouped[key]) {
      grouped[key].push(ticket);
    } else {
      grouped[key] = [ticket];
    }
  }
  return grouped;
};
var getEventStatus = (event, locale) => {
  var _a;
  if (!event) {
    return {
      message: "no_tickets_available",
      disabled: true
    };
  }
  const tickets = event.event_tickets;
  const external_links = (_a = event == null ? void 0 : event.tickets_external_link) == null ? void 0 : _a[locale || ""];
  if (external_links) {
    return {
      message: "more_details",
      disabled: false
    };
  }
  if (tickets.length <= 0)
    return {
      message: "no_tickets_available",
      disabled: true
    };
  if (tickets.every((ticket) => ticket.sold_out || ticket.remaining <= 0)) {
    return {
      message: "sold_out",
      disabled: true
    };
  }
  if (tickets.every((ticket) => ticket.sale_status === "past")) {
    return {
      message: "sales_ended",
      disabled: true
    };
  }
  return {
    message: "buy_tickets",
    disabled: false
  };
};
var getAvailableTickets = (tickets) => {
  return tickets.filter((ticket) => ticket.remaining > 0 && !ticket.sold_out);
};
var getEventLimits = ({
  event,
  isSeason
}) => {
  const limits = {};
  const subLimits = (event == null ? void 0 : event.subscription_ticket_type_limits) || [];
  let total = 0;
  if (subLimits.length > 0) {
    for (const limit of subLimits) {
      const maxTickets = +limit.limit || 0;
      limits[limit.ticket_type_id] = maxTickets;
      total += maxTickets;
    }
  } else {
    const maxPerOrder = isSeason ? Number(event.season_order_limit) : Number(event == null ? void 0 : event.event_order_limit);
    total = maxPerOrder;
  }
  return {
    total,
    perSubscriptionTicketType: limits
  };
};
var hasSomeTicketsForSale = (tickets, slot) => {
  if (!slot || typeof slot !== "object") {
    return true;
  }
  for (const key in slot) {
    const quantity = Number(slot[key]) || 0;
    const ticket = tickets.find((t) => t._id === key);
    if (ticket && quantity > 0) {
      return true;
    }
  }
  return false;
};
var getTicketTypesForSeatIoCategory = (tickets, seatsIoCategory) => {
  var _a, _b;
  const types = [];
  for (const ticket of tickets) {
    const hasType = !!((_a = ticket == null ? void 0 : ticket.ticket_type) == null ? void 0 : _a.slug) && !!((_b = ticket == null ? void 0 : ticket.ticket_type) == null ? void 0 : _b.title);
    const key = Number(ticket.seats_io_category);
    if (hasType && key === seatsIoCategory) {
      const price = ticket.priceWithFee + ticket.vatWithFee;
      types.push({
        label: ticket.ticket_type.title,
        ticketType: ticket.ticket_type.slug,
        price,
        originalPrice: +ticket.priceWithFee !== +ticket.originalPriceWithFee ? +ticket.originalPriceWithFee : void 0
      });
    }
  }
  if (types.length > 0) {
    return types;
  }
};
var parseEventToAnalyticsEvent = (event) => {
  var _a, _b;
  return {
    _id: (event == null ? void 0 : event._id) || "",
    slug: (event == null ? void 0 : event.slug) || "",
    poster: (event == null ? void 0 : event.poster) || "",
    organization_slug: ((_a = event == null ? void 0 : event.organization) == null ? void 0 : _a.slug) || "",
    dubai_provider: event == null ? void 0 : event.dubai_provider,
    title: (event == null ? void 0 : event.title) || "",
    startingPrice: event == null ? void 0 : event.event_start_price,
    currencyCode: event == null ? void 0 : event.currency,
    category: (event == null ? void 0 : event.category) || ((_b = event == null ? void 0 : event.tags) == null ? void 0 : _b[0]) || "N/A",
    zone: (event == null ? void 0 : event.venue_name) || "N/A",
    start_date_time: event == null ? void 0 : event.start_date_time
  };
};

export {
  listTicketsByGroup,
  groupTicketsByGroupName,
  getEventStatus,
  getAvailableTickets,
  getEventLimits,
  hasSomeTicketsForSale,
  getTicketTypesForSeatIoCategory,
  parseEventToAnalyticsEvent
};
//# sourceMappingURL=chunk-HGCJUMLB.mjs.map